import type { FileIdentity, WizardFile, WizardFileKind } from '../../Model/OrderWizard/OrderWizardDraft.ts'
import { fileKeyOf } from '../../Model/OrderWizard/OrderWizardDraft.ts'

const FASTQ = /\.(fastq|fq)(\.gz)?$/i
const SHEET = /\.(csv|tsv|xlsx|xls)$/i

export const fileKindOf = (name: string): WizardFileKind => {
  if (FASTQ.test(name)) {
    return 'fastq'
  }
  if (SHEET.test(name)) {
    return 'sheet'
  }
  return 'other'
}

export const DROPZONE_ACCEPT = '.fastq,.fq,.gz,.csv,.tsv,.xlsx,.xls'

export const identityOf = (file: FileIdentity): FileIdentity => ({ name: file.name, size: file.size, lastModified: file.lastModified })

/** A freshly dropped file as the draft records it. Sheets and unknown files are listed, never uploaded. */
export const toWizardFile = (file: FileIdentity): WizardFile => {
  const kind = fileKindOf(file.name)
  const base = { ...identityOf(file), key: fileKeyOf(file), kind }
  if (kind === 'other') {
    return { ...base, rejection: 'Not a FASTQ file (.fastq/.fq, optionally .gz)' }
  }
  return base
}

export const defaultDraftName = (now: Date): string => {
  const pad = (n: number) => String(n).padStart(2, '0')
  return `Order ${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`
}
